import { APP_DEFINITION_ID } from './appAndWidgetIds';

// Signup form configuration
export const SIGNUP_FORM_ID = '78384e16-7b4d-4fab-7227-f687b3545659';
export const SIGNUP_FORM_NAMESPACE = 'wix.identity.sm.v1.form';
export const APP_DASHBOARD_URL = `/app/${APP_DEFINITION_ID}/`;
